


/** ******  pNotify  *********************** **/
function notification(kind, title, text, type, icon, btnName) { 

    var stack_modal = {"dir1": "down", "dir2": "right", "push": "top", "modal": true, "overlay_close": true};
    if(kind == 'notify') {
        var notice =  new PNotify({
            title: title, text: text, type: type, delay: '5000',
    		styling: 'fontawesome',
            nonblock: { nonblock: true, nonblock_opacity: .2 },
            buttons: { closer: true, sticker: false, closer_hover: false, show_on_nonblock: true }
        });
        return notice.get().click(function() { notice.remove(); });
    }
    else if(kind == 'prompt') {
        return new PNotify({
            title: title, text: text, type: type, icon: icon, hide: false,
    		styling: 'fontawesome',
            confirm: { prompt: true }, buttons: { closer: false, sticker: false },
            history: { history: false }, addclass: 'stack-modal', stack: stack_modal
        });
    }
    else if(kind == 'modal-alert') {
        $(".ui-pnotify-modal-overlay").css("display","block");
        return new PNotify({
            title: title,
            text: text,
            type: type,
            icon: icon,
            hide: false,
    		styling: 'fontawesome',
            confirm: { confirm: true,
                buttons: [
                    {
                        text: (btnName == "" ? "OK" : btnName),
                        addClass: 'btn-sm',
                        click: function(notice) {
                            notice.remove();
                            notice.get().trigger("pnotify.confirm", notice);
                            $(".ui-pnotify-modal-overlay").css("display","none");
                        }
                    },
                    null
                ]
            },
            buttons: { closer: false, sticker: false },
            history: { history: false },
            addclass: 'stack-modal',
            stack: stack_modal
        });
    }
    else if(kind == 'confirm') {
        $(".ui-pnotify-modal-overlay").css("display","block");
        return (new PNotify({
            title: title,
            text: text,
            type: type,
            icon: icon,
            hide: false,
            styling: 'bootstrap3',
            confirm: {
                confirm: true,
                buttons: [
                    {
                        addClass: 'btn-sm',
                        click: function(notice) {
                            notice.remove();
                            notice.get().trigger("pnotify.confirm", notice);
                            $(".ui-pnotify-modal-overlay").css("display","none");
                        }
                    },
                    {
                        addClass: 'btn-sm',
                        click: function(notice) {
                            notice.remove();
                            notice.get().trigger("pnotify.cancel", notice);
                            $(".ui-pnotify-modal-overlay").css("display","none");
                        }
                    },
                    null
                ]
            },
            buttons: {
                closer: false,
                sticker: false
            },
            history: {
                history: false
            },
            addclass: 'stack-modal',
            stack: {
                'dir1': 'down',
                'dir2': 'right',
                'modal': true
            }
        }));
    }
}
/** ******  /pNotify  *********************** **/